import { render, staticRenderFns } from "./titlebox.vue?vue&type=template&id=25a6a60e&scoped=true&"
import script from "./titlebox.vue?vue&type=script&lang=js&"
export * from "./titlebox.vue?vue&type=script&lang=js&"
import style0 from "./titlebox.vue?vue&type=style&index=0&id=25a6a60e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a6a60e",
  null
  
)

export default component.exports